export default __webpack_public_path__ + "static/media/avatar_user.8c0b364e.png";